module.exports = __webpack_public_path__ + "img/article_7_1.c2883dbb.png";